import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1426_4967" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="2" width="20" height="16">
        <path
          d="M20 10.125C20 9.025 19.1 8.125 18 8.125H16.84L16 3.905C16 3.905 16 3.885 16 3.875C16 3.185 15.44 2.625 14.75 2.625H5.25C4.56 2.625 4 3.185 4 3.875C4 3.875 4 3.895 4 3.905L3.16 8.125H2C0.9 8.125 0 9.025 0 10.125V14.125H2.01C2.01 14.125 2 14.205 2 14.245V15.365C2 16.335 2.78 17.115 3.75 17.115C4.72 17.115 5.5 16.335 5.5 15.365V14.245C5.5 14.245 5.5 14.165 5.49 14.125H14.01C14.01 14.125 14 14.205 14 14.245V15.365C14 16.335 14.78 17.115 15.75 17.115C16.72 17.115 17.5 16.335 17.5 15.365V14.245C17.5 14.245 17.5 14.165 17.49 14.125H20V10.125ZM3.6 12.325C2.72 12.325 2 11.605 2 10.725C2 9.845 2.72 9.125 3.6 9.125C4.48 9.125 5.2 9.845 5.2 10.725C5.2 11.605 4.48 12.325 3.6 12.325ZM5.2 8.125L5.8 5.125H14.2L14.8 8.125H5.2ZM15.6 12.325C14.72 12.325 14 11.605 14 10.725C14 9.845 14.72 9.125 15.6 9.125C16.48 9.125 17.2 9.845 17.2 10.725C17.2 11.605 16.48 12.325 15.6 12.325Z"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_1426_4967)">
        <rect y="-0.375" width="20" height="20" fill="black" />
      </g>
    </svg>
  );
};

export default Icon;
